import { t } from "i18next";

export const reasons = {
    Private: t('Calendar.private'),
    'Sick leave': t('Calendar.sickLeave'),
    'Lunch break': t('Calendar.lunchBreak'),
    Vacation: t('Calendar.vacation'),
    'Time off': t('Calendar.timeOff'),
    'Course training': t('Calendar.courseTraining'),
    School: t('Calendar.school'),
    ChildSickLeave: t('Calendar.childSickLeave'),
    'Parental leave': t('Calendar.parentalLeave'),
};